export const ACAD_COLORS = {
  primary: '#EA6025',
  secondary: '#D4520E',
  accent: '#FB923C',
  light: '#FFF7ED',
  dark: '#3D1706',
} as const

export const RESOURCE_TYPE_COLORS: Record<string, string> = {
  journal: '#8B5CF6',
  video: '#EF4444',
  audio: '#3B82F6',
  image: '#22C55E',
  website: '#14B8A6',
  course: '#F59E0B',
  document: '#6B7280',
}
